export const buildRedirectUrl = (baseHost: string): string => {
  let innerBaseHost = baseHost;

  if (location.port.length) {
    innerBaseHost += ':' + location.port;
  }

  return innerBaseHost + location.pathname + location.search;
};
